import { createContext } from 'react';
import { DeepCopy } from '../components/tables/shared/TableEventHelpers';
import { EMP_TABLE_ADDRESS_COL, EMP_TABLE_BIRTHDATE_COL, EMP_TABLE_BOSS_COL, EMP_TABLE_COMPANY_COL, EMP_TABLE_COMPETENCE_COL, EMP_TABLE_EMAIL_COL, EMP_TABLE_END_DATE_COL, EMP_TABLE_HOURS_COL, EMP_TABLE_NAME_COL, EMP_TABLE_OFFICE_COL, EMP_TABLE_PHONE_COL, EMP_TABLE_ROLE_COL, EMP_TABLE_START_DATE_COL, EMP_TABLE_STATUS_COL, EMP_IS_WORKING } from '../i18n/keyConstants';

const hiddenColumns = ['phone', 'email', 'birthDate', 'address', 'skills', 'hours', 'startDate', 'endDate'];
const defaultHiddenColumns = ['phone', 'email', 'birthDate', 'address', 'skills', 'hours', 'startDate', 'endDate'];

const selectedFilters = {
    name: '',
    boss: '',
    company: '',
    hours: '',
    phone: '',
    email: '',
    birthDate: '',
    address: '',
    skills: '',
    startDate: '',
    endDate: '',
};

const tableColumnExtensions = [
    { columnName: 'name', width: 230 },
    { columnName: 'role', width: 220 },
    { columnName: 'boss', width: 230 },
    { columnName: 'office', width: 230 },
    { columnName: 'company', width: 230 },
    { columnName: 'status', width: 230 },
    { columnName: 'hours', width: 170, align: 'right' },
    { columnName: 'phone', width: 230 },
    { columnName: 'email', width: 230 },
    { columnName: 'birthDate', width: 230 },
    { columnName: 'address', width: 230 },
    { columnName: 'skills', width: 230 },
    { columnName: 'startDate', width: 230 },
    { columnName: 'endDate', width: 230 },
];

export const initialState = {
    employees: [],
    filters: [{ columnName: 'status', operation: 'equal', value: 'isWorking' }],
    requestUri: null,
    defaultFilters: [{ columnName: 'status', operation: 'equal', value: 'isWorking' }],
    hiddenColumns: defaultHiddenColumns,
    showCustomCols: false,
    columnName: 'name',
    tableSize: 0,
    direction: 'asc',
    pageSize: 25,
    currentPage: 1,
    sortInfo: {},
    isLoading: true,
    error: null,
    columns: [
        { title: EMP_TABLE_NAME_COL, name: 'name' },
        { title: EMP_TABLE_ROLE_COL, name: 'role' },
        { title: EMP_TABLE_BOSS_COL, name: 'boss' },
        { title: EMP_TABLE_COMPANY_COL, name: 'company' },
        { title: EMP_TABLE_HOURS_COL, name: 'hours' },
        { title: EMP_TABLE_OFFICE_COL, name: 'office' },
        { title: EMP_TABLE_STATUS_COL, name: 'status' },
        { title: EMP_TABLE_PHONE_COL, name: 'phone' },
        { title: EMP_TABLE_EMAIL_COL, name: 'email' },
        { title: EMP_TABLE_BIRTHDATE_COL, name: 'birthDate' },
        //{ title: EMP_TABLE_ADDRESS_COL, name: 'address' },
        { title: EMP_TABLE_COMPETENCE_COL, name: 'skills' },
        { title: EMP_TABLE_START_DATE_COL, name: 'startDate' },
        { title: EMP_TABLE_END_DATE_COL, name: 'endDate' },
    ],
    expandedRowIDs: [],
    selectedOffice: null,
    selectedRole: null,
    selectedStatus: [{ label: EMP_IS_WORKING, value: 'isWorking' }],
    selectedFilters: selectedFilters,
    isResettingFilters: false,
    tableColumnExtensions,
    defaultTableColumnExtensions: tableColumnExtensions,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                employees: action.employees,
                tableSize: action.totalRows,
                isLoading: false,
                expandedRowIDs: [],
            };
        case 'FETCH_ERROR':
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case 'SET_ISLOADING_TRUE':
            return {
                ...state,
                isLoading: true,
            };
        case 'SET_ISLOADING_FALSE':
            return {
                ...state,
                isLoading: false,
            };
        case 'FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
            };
        case 'SET_REQUEST_URI':
            return {
                ...state,
                requestUri: action.payload,
            };
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: [{ columnName: 'status', operation: 'equal', value: 'isWorking' }],
                defaultFilters: [{ columnName: 'status', operation: 'equal', value: 'isWorking' }],
                currentPage: 1,
                selectedOffice: null,
                selectedRole: null,
                selectedStatus: [{ label: EMP_IS_WORKING, value: 'isWorking' }],
                isResettingFilters: true,
            };
        case 'FILTERS_RESET':
            return {
                ...state,
                isResettingFilters: false,
            };
        case 'OFFICE_HOURS':
            return {
                ...state,
                filters: [...initialState.filters, ...action.payload],
                defaultFilters: [...initialState.defaultFilters, ...action.payload],
                currentPage: 1,
            };
        case 'PAGESIZE':
            return {
                ...state,
                pageSize: action.payload,
            };
        case 'HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: action.payload,
            };
        case 'RESET_HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: defaultHiddenColumns,
                showCustomCols: false,
            };
        case 'SHOW_CUSTOM_COLS':
            return {
                ...state,
                showCustomCols: action.payload,
            };
        case 'HIDDEN_COLUMNS_AND_CUSTOM_COLS':
            return {
                ...state,
                hiddenColumns: action.hiddenColumns,
                showCustomCols: action.showCustomCols,
            };
        case 'CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload,
            };
        case 'SORT_INFO':
            return {
                ...state,
                sortInfo: action.sortInfo,
                columnName: action.columnName,
                direction: action.direction,
            };
        case 'UPDATE_ROW_DETAILS':
            return {
                ...state,
                expandedRowIDs: action.payload,
            };
        case 'SELECTED_OFFICE':
            return {
                ...state,
                selectedOffice: action.payload,
            };
        case 'SELECTED_ROLE':
            return {
                ...state,
                selectedRole: action.payload,
            };
        case 'SELECTED_STATUS':
            return {
                ...state,
                selectedStatus: action.payload,
            };
        case 'SELECTED_FILTERS':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
            };
        case 'SELECTED_FILTERS_AND_FILTERS_RESET':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
                isResettingFilters: false,
            };
        case 'FILTERS_AND_SELECTED_FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.columnNameVal }),
            };
        case 'DESKTOP_COLUMN_WIDTHS':
            return {
                ...state,
                tableColumnExtensions,
            };
        case 'MOBILE_COLUMN_WIDTHS':
            return {
                ...state,
                tableColumnExtensions: tableColumnExtensions.map((c) => (c.columnName !== 'hours' ? c.width === 'auto' : '')),
            };
        case 'NAVIGATION_FROM_INTERNALHOURS':
            let newHiddenColumns = DeepCopy(hiddenColumns);
            let hoursIndex = newHiddenColumns.indexOf('hours');
            if (hoursIndex !== -1) {
                newHiddenColumns.splice(hoursIndex, 1);
            }
            return {
                ...state,
                selectedOffice: [{ value: action.rowName, label: action.rowName }],
                filters: [
                    ...initialState.filters,
                    ...[
                        { columnName: 'office', operation: 'equal', value: action.rowName },
                        { columnName: 'hours', value: '1', operation: 'greaterThanOrEqual' },
                    ],
                ],
                defaultFilters: [
                    ...initialState.defaultFilters,
                    ...[
                        { columnName: 'office', operation: 'equal', value: action.rowName },
                        { columnName: 'hours', value: '1', operation: 'greaterThanOrEqual' },
                    ],
                ],
                currentPage: 1,
                hiddenColumns: newHiddenColumns,
                showCustomCols: true,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
